import { Row, Col, Container, Card, Form, Button, Table, Badge, Dropdown, Modal, Spinner } from "react-bootstrap";
import Layout from "../components/Layout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Paginator from "../components/table/Paginator";
import { useEffect, useState } from "react";
import receipt_avatar from '../assets/images/receipt.svg';
import DrewsModal from "../components/modal/DrewsModal";
import { useDispatch } from "react-redux";
import { getTransactionHistory, inflowAnalytics } from "../redux/slices/account.service";
import formatCurrency from "../utils/currencyFormmter";
import Logo from "../components/Logo";
import dateFormatter from "../utils/dateFormatter";
import RecordFilter from "../components/RecordFilter";

const lsetfLogo = "data:image/jpeg;base64,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";

const loanProviders = [
  {
    id: "lsetf",
    name: "LSETF",
    fullName: "Lagos State Employment Trust Fund",
    logo: lsetfLogo,
    tagline: "Single Digit Interest Rate Loan",
    interestRate: "9%",
    interestLabel: "per annum",
    accent: "#1a7a4a",
    bg: "linear-gradient(135deg, #e8f5ee 0%, #f0faf4 100%)",
    badgeText: "Government",
    badgeBg: "#1a7a4a",
    applyUrl: "https://loans.lsetf.ng",
    requirements: [
      "LIRS ID",
      "LASSRA ID",
      "Government Issued ID (International Passport, Drivers License, Voters Card etc.)",
      "Bank Verification Number (BVN)",
      "Guarantor",
    ],
    description:
      "LSETF provides affordable single digit interest rate loans to Lagos State residents to support business growth, job creation and economic empowerment.",
  },
];

const LoanRequest = () => {
  const dispatch = useDispatch();

  const months = [
    "January","February","March","April","May","June",
    "July","August","September","October","November","December",
  ];

  const [activeTab, setActiveTab] = useState("all");
  const [month, setMonth] = useState(1);
  const [modalShow, setModalShow] = useState(false);
  const [transaction, setTransaction] = useState({});
  const [transactions, setTransactions] = useState([]);
  const [results, setResults] = useState([]);
  const [analytics, setAnalytics] = useState({});
  const [receipt, setReceipt] = useState({});
  const [show_receipt, setShowReceipt] = useState(false);
  const [copiedText, setCopiedText] = useState("");
  const [paginationData, setpaginationData] = useState({ next: "", prev: "" });
  const [inflow_analytics, setInflowData] = useState({});
  const [selectedProvider, setSelectedProvider] = useState(null);
  const [payload, setPayload] = useState({
    page: 1, from_date: "", to_date: "", status: "",
    download: "", filter_by: "", sort_by: "", filter: "",
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadInflowData();
  }, [0, dateFormatter, payload.page]);

  const nextMonth = () => { if (month < 11) setMonth((prev) => ++prev); };
  const prevMonth = () => { if (month > 0) setMonth((prev) => --prev); };

  const selectTransaction = (id) => {
    const transaction = transactions.filter((item) => item.reference === id)[0];
    if (transaction.note === "Electricity") {
      setReceipt(transaction);
      setShowReceipt(true);
    } else {
      setTransaction(transaction);
      setModalShow(true);
    }
  };

  const loadTransactions = () => {
    setLoading(true);
    dispatch(getTransactionHistory(payload))
      .then((response) => {
        if (response.payload.results) {
          setTransactions(response.payload.results);
          setTimeout(() => filterTransactions(response.payload.results, "all"), 1000);
        }
        if (response.payload?.analytics) setAnalytics(response.payload.analytics);
        if (response.payload?.next || response.payload?.previous) {
          setpaginationData({ next: response.payload?.next, prev: response.payload?.previous });
        }
      })
      .finally(() => setLoading(false));
  };

  const loadInflowData = () => {
    dispatch(inflowAnalytics()).then((response) => { setAnalytics(response.payload); });
  };

  const filterTransactions = (payload = transactions, value) => {
    if (value.toLowerCase().includes("voucher")) setActiveTab("vouchers");
    else if (value.toLowerCase().includes("invoice")) setActiveTab("invoices");
    else setActiveTab(value);
  };

  const handleCopy = (copyText) => {
    navigator.clipboard.writeText(copyText).then(() => setCopiedText(copyText));
  };

  const handlePagination = (data) => setPayload({ ...payload, page: data });
  const handleInput = (event) => {
    const { name, value } = event.target;
    setPayload((prev) => ({ ...prev, [name]: value }));
  };
  const handleSearch = () => loadTransactions();

  return (
    <Layout>
      <Container className="mt-4 px-4 mb-4">
        <Col md={12} className="d-flex align-items-center justify-content-between">
          <h3>Available Loan Providers for your Business</h3>
          <div className="months-toggle shadow-sm">
            <Button type="button" variant="light" size="sm" onClick={prevMonth}>
              <i className="lni lni-chevron-left"></i>
            </Button>
            <span>{months[month]}</span>
            <Button type="button" variant="light" size="sm" onClick={nextMonth}>
              <i className="lni lni-chevron-right"></i>
            </Button>
          </div>
        </Col>

        {loading ? (
          <div className="page-loader"><Spinner size="lg" variant="primary" /></div>
        ) : null}

        {/* ── ANALYTICS CARDS ── */}
        <div className="mt-4">
          <Row className="data-card mb-3">
            <Col md={4} sm={12} xs={12} lg={3} className="mb-2">
              <Card className="border-0 shadow-sm bg--primary">
                <Card.Body className="d-flex align-items-center gap-3 p-4">
                  <div className="icon">
                    <i className="lni lni-notepad" style={{ fontSize: "25px" }}></i>
                  </div>
                  <div>
                    <h5 className="m-0">{formatCurrency(analytics?.five_percent_of_all_time).with_currency}</h5>
                    <p className="m-0">Amount Eligible Today</p>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4} sm={12} xs={12} lg={3} className="mb-2">
              <Card className="border-0 shadow-sm">
                <Card.Body className="d-flex align-items-center gap-3 p-4">
                  <div className="icon bg-light">
                    <img src={receipt_avatar} alt="receipt" width={25} />
                  </div>
                  <div>
                    <h5 className="m-0">{'0'}</h5>
                    <p className="m-0">Total Loan Providers</p>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4} sm={12} xs={12} lg={3} className="mb-2">
              <Card className="border-0 shadow-sm bg--secondary">
                <Card.Body className="d-flex align-items-center gap-3 p-4">
                  <div className="icon">
                    <FontAwesomeIcon icon="tag" style={{ fontSize: "25px" }} />
                  </div>
                  <div>
                    <h5 className="m-0">{'0'}</h5>
                    <p className="m-0">No. of Loan Request</p>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4} sm={12} xs={12} lg={3} className="mb-2">
              <Card className="border-0 shadow-sm bg--secondary">
                <Card.Body className="d-flex align-items-center gap-3 p-4">
                  <div className="icon">
                    <FontAwesomeIcon icon="credit-card" style={{ fontSize: "25px" }} />
                  </div>
                  <div>
                    <h5 className="m-0">{'0'}</h5>
                    <p className="m-0">Your Credit Score</p>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* ── LOAN PROVIDERS GRID ── */}
          <div className="mb-4">
            <h6 className="fw-bold mb-1">Loan Providers</h6>
            <p className="text-muted small mb-3">Click a provider to view details and apply.</p>
            <Row className="g-3">
              {loanProviders.map((provider) => (
                <Col key={provider.id} xs={12} sm={6} lg={4}>
                  <Card
                    className="border-0 shadow-sm h-100"
                    style={{
                      borderRadius: "16px",
                      overflow: "hidden",
                      cursor: "pointer",
                      transition: "transform 0.2s ease, box-shadow 0.2s ease",
                    }}
                    onClick={() => setSelectedProvider(provider)}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-4px)";
                      e.currentTarget.style.boxShadow = "0 12px 32px rgba(0,0,0,0.12)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "";
                    }}
                  >
                    {/* Banner */}
                    <div
                      style={{
                        background: provider.bg,
                        padding: "20px 20px 16px",
                        borderBottom: `3px solid ${provider.accent}25`,
                        position: "relative",
                      }}
                    >
                      {/* Logo pill — top right */}
                      <div
                        style={{
                          position: "absolute",
                          top: "14px",
                          right: "14px",
                          background: "#fff",
                          borderRadius: "10px",
                          padding: "5px 8px",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.10)",
                          width: "80px",
                          height: "46px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <img
                          src={provider.logo}
                          alt={`${provider.name} logo`}
                          style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }}
                        />
                      </div>

                      {/* Left content */}
                      <div style={{ paddingRight: "90px" }}>
                        <span
                          style={{
                            background: provider.badgeBg,
                            color: "#fff",
                            fontSize: "0.68rem",
                            fontWeight: 700,
                            borderRadius: "6px",
                            padding: "2px 10px",
                            display: "inline-block",
                            marginBottom: "8px",
                          }}
                        >
                          {provider.badgeText}
                        </span>
                        <h6 className="fw-bold mb-0" style={{ color: provider.accent, fontSize: "1rem" }}>
                          {provider.name}
                        </h6>
                        <p className="mb-0 text-muted" style={{ fontSize: "0.74rem" }}>
                          {provider.fullName}
                        </p>
                      </div>
                    </div>

                    {/* Body */}
                    <Card.Body className="px-3 py-3">
                      {/* Interest rate highlight */}
                      <div
                        className="d-flex align-items-center gap-2 mb-2 px-3 py-2 rounded-3"
                        style={{ background: `${provider.accent}12`, border: `1px solid ${provider.accent}25` }}
                      >
                        <span style={{ fontSize: "1.3rem" }}>💰</span>
                        <div>
                          <p className="mb-0 fw-bold" style={{ color: provider.accent, fontSize: "1rem" }}>
                            {provider.interestRate}
                            <span className="fw-normal text-muted" style={{ fontSize: "0.72rem" }}>
                              {" "}{provider.interestLabel}
                            </span>
                          </p>
                          <p className="mb-0 text-muted" style={{ fontSize: "0.72rem" }}>
                            {provider.tagline}
                          </p>
                        </div>
                      </div>

                      <p className="text-muted mb-3" style={{ fontSize: "0.82rem", lineHeight: "1.55" }}>
                        {provider.description}
                      </p>

                      <button
                        className="btn btn-sm w-100 fw-semibold"
                        style={{
                          background: provider.accent,
                          color: "#fff",
                          borderRadius: "8px",
                          border: "none",
                          padding: "8px",
                          fontSize: "0.82rem",
                        }}
                        onClick={(e) => { e.stopPropagation(); setSelectedProvider(provider); }}
                      >
                        View & Apply →
                      </button>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </div>

          <RecordFilter handleInput={handleInput} handleSearchSubmit={handleSearch} />

          {/* ── TRANSACTIONS TABLE ── */}
          <Card className="border-0 shadow-sm">
            <Card.Body className="table-responsive">
              <Table size="sm" className="table-color table-stripedd">
                <thead>
                  <tr>
                    <th>Details</th>
                    <th>Order</th>
                    <th>Amount</th>
                    <th>Balance Before</th>
                    <th>Balance After</th>
                    <th>Type</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {results?.length ? (
                    results.map((item, index) => (
                      <tr key={index}>
                        <td>
                          <div className="m-0 d-flex gap-2 align-items-center">
                            <small className={item.status === "success" ? "drews-badge drews-badge-success-circle" : "drews-badge drews-badge-error-circle"}>
                              <i className="lni lni-arrow-top-right"></i>
                            </small>
                            <strong>
                              <p className="m-0">{item.note}</p>
                              <small>{dateFormatter(item.date)}</small>
                            </strong>
                          </div>
                        </td>
                        <td>{item.order}</td>
                        <td>{formatCurrency(item.amount, item.currency).with_currency}</td>
                        <td>{formatCurrency(item.amount_before, item.currency).with_currency}</td>
                        <td>{formatCurrency(item.amount_after, item.currency).with_currency}</td>
                        <td>
                          <p className="m-0 d-flex align-items-center gap-2">
                            <FontAwesomeIcon icon="fa fa-money-check" />
                            {item.transaction_type}
                          </p>
                        </td>
                        <td>
                          <div className="d-flex m-0 align-items-center justify-content-between">
                            <Badge className={item.status === "success" ? "badge-active" : (item.status === "failed" ? "badge-failed" : (item.status === "used" ? "badge-used" : "badge-pending"))}>
                              <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                                <circle cx="5" cy="5" r="5" fill={item.status === "success" ? "#008000" : (item.status === "failed" ? "#EB5757" : (item.status === "used" ? "#828282" : "#FAB941"))} />
                              </svg>
                              <span className="ps-1">{item.status}</span>
                            </Badge>
                            <Dropdown>
                              <Dropdown.Toggle variant="light" className="border-0 bg-transparent" size="sm">
                                <FontAwesomeIcon icon="ellipsis-vertical" style={{ fontSize: "20px" }} className="text-muted" />
                              </Dropdown.Toggle>
                              <Dropdown.Menu className="border-0 shadow px-3 py-4">
                                <Dropdown.Item eventKey={1} className="text-primary d-flex align-items-center gap-1" onClick={() => selectTransaction(item.reference)}>
                                  <i className="lni lni-eye" style={{ fontSize: "20px" }}></i> View Details
                                </Dropdown.Item>
                                <Dropdown.Divider />
                                <Dropdown.Item eventKey={2} className="text-danger d-flex align-items-center gap-1" onClick={() => selectTransaction(item.reference)}>
                                  <i className="lni lni-question-circle"></i> Report Transaction
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={7} className="text-center text-muted py-3">No data found</td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </Card.Body>
          </Card>

          {results?.length ? (
            <div className="table-responsive mt-2">
              <Paginator next={paginationData.next} prev={paginationData.prev} setCurrentPage={handlePagination} />
            </div>
          ) : null}
        </div>

        {/* ── LSETF PROVIDER DETAIL MODAL ── */}
        {selectedProvider && (
          <Modal
            show={!!selectedProvider}
            onHide={() => setSelectedProvider(null)}
            centered
            size="md"
          >
            <Modal.Header
              closeButton
              style={{
                background: selectedProvider.bg,
                borderBottom: `2px solid ${selectedProvider.accent}25`,
                padding: "20px 24px 16px",
              }}
            >
              <div className="d-flex align-items-center gap-3 w-100">
                <div
                  style={{
                    background: "#fff",
                    borderRadius: "10px",
                    padding: "6px 10px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.10)",
                    width: "80px",
                    height: "46px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <img
                    src={selectedProvider.logo}
                    alt="logo"
                    style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }}
                  />
                </div>
                <div>
                  <h6 className="fw-bold mb-0" style={{ color: selectedProvider.accent }}>
                    {selectedProvider.name}
                  </h6>
                  <p className="mb-0 text-muted" style={{ fontSize: "0.75rem" }}>
                    {selectedProvider.tagline}
                  </p>
                </div>
              </div>
            </Modal.Header>

            <Modal.Body className="px-4 py-4">
              {/* Interest rate badge */}
              <div
                className="d-flex align-items-center justify-content-between rounded-3 px-3 py-3 mb-4"
                style={{ background: `${selectedProvider.accent}10`, border: `1px solid ${selectedProvider.accent}25` }}
              >
                <div>
                  <p className="mb-0 text-muted" style={{ fontSize: "0.75rem" }}>Interest Rate</p>
                  <h4 className="mb-0 fw-bold" style={{ color: selectedProvider.accent }}>
                    {selectedProvider.interestRate}
                    <span className="fw-normal text-muted" style={{ fontSize: "0.8rem" }}>
                      {" "}{selectedProvider.interestLabel}
                    </span>
                  </h4>
                </div>
                <span style={{ fontSize: "2.2rem" }}>🏦</span>
              </div>

              {/* Description */}
              <p className="text-muted mb-3" style={{ fontSize: "0.85rem", lineHeight: "1.6" }}>
                {selectedProvider.description}
              </p>

              {/* Requirements */}
              <div className="mb-4">
                <p className="fw-bold mb-2" style={{ fontSize: "0.87rem" }}>
                   Application Requirements
                </p>
                <ul className="ps-3 mb-0" style={{ fontSize: "0.83rem", lineHeight: "2" }}>
                  {selectedProvider.requirements.map((req, i) => (
                    <li key={i} className="text-muted">{req}</li>
                  ))}
                </ul>
              </div>

              {/* CTA */}
              <a
                href={selectedProvider.applyUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="btn w-100 fw-bold py-2"
                style={{
                  background: `linear-gradient(135deg, ${selectedProvider.accent}, ${selectedProvider.accent}cc)`,
                  color: "#fff",
                  borderRadius: "10px",
                  fontSize: "0.9rem",
                  textDecoration: "none",
                  boxShadow: `0 4px 14px ${selectedProvider.accent}40`,
                }}
              >
                 Apply Now on LSETF Portal
              </a>
              <p className="text-center text-muted mt-2 mb-0" style={{ fontSize: "0.72rem" }}>
                You will be redirected to <strong>loans.lsetf.ng</strong>
              </p>
            </Modal.Body>
          </Modal>
        )}

        {/* ── TRANSACTION DETAIL MODAL ── */}
        <DrewsModal
          show={modalShow}
          onHide={() => setModalShow(false)}
          size="lg"
          dismissable={true}
          title={transaction.reference}
          badge_text={transaction.type}
        >
          <Row>
            <Col md={6}>
              <div className="modal-profile">
                <ul>
                  <li><div><p className="pt-2"><small className="text-muted">Transaction ID</small>{transaction.reference}</p></div></li>
                  <li><div><p className="pt-2"><small className="text-muted">Note</small>{transaction?.note || "Nil"}</p></div></li>
                  <li><div><p className="pt-2"><small className="text-muted">Beneficiary Account</small>{transaction?.balance || "Nil"}</p></div></li>
                  <li>
                    <div>
                      <p className="pt-2">
                        <small className="text-muted">Status</small>
                        <span className={transaction.status === "success" ? "text-success" : (transaction.status === "failed" ? "text-danger" : (transaction.status === "used" ? "text-dark" : "text-warning"))}>
                          {transaction.status}
                        </span>
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </Col>
            <Col md={6} className="modal-profile">
              <ul>
                <li><div><p className="pt-2"><small className="text-muted">Amount</small>{formatCurrency(transaction.amount).with_currency}</p></div></li>
                <li><div><p className="pt-2"><small className="text-muted">Fee</small>{formatCurrency(transaction.fee).with_currency}</p></div></li>
                <li><div><p className="pt-2"><small className="text-muted">Transaction Date</small>{transaction.date}</p></div></li>
              </ul>
            </Col>
          </Row>
        </DrewsModal>

        {/* ── ELECTRICITY RECEIPT MODAL ── */}
        <Modal show={show_receipt} fullscreen={true} onHide={() => setShowReceipt(false)} dialogClassName="receipt-screen-modal" backdrop="static">
          <Modal.Header>
            <button className="btn-plain">
              <FontAwesomeIcon icon="chevron-left" onClick={() => setShowReceipt(false)} />
            </button>
          </Modal.Header>
          <Modal.Body className="p-2">
            <div className="invoice px-3 py-0 border border-0">
              <div className="border-bottom border-bottom-1 d-flex align-items-center justify-content-between pb-2 py-2">
                <Logo variant="dark" />
                <div>
                  <h5 className="mb-0 text-right">Transaction Receipt</h5>
                  <p className="text-muted text-sm m-0 text-right">Generated: {receipt.date !== null ? dateFormatter(receipt.date) : ""}</p>
                </div>
              </div>
              <div className="table-responsive mb-3">
                <table className="table border-0">
                  <tbody>
                    <tr><td className="text-muted text-sm w-50 border-0">Transaction Amount</td><td className="text-primary border-0 text-right">{formatCurrency(receipt.amount).with_currency}</td></tr>
                    <tr><td className="text-muted text-sm w-50 border-0">Transaction Type</td><td className="text-primary border-0 text-right">{receipt?.bill_type}</td></tr>
                    <tr><td className="text-muted text-sm w-50 border-0">Service Provider</td><td className="text-primary border-0 text-right">{receipt?.provider || "Nill"}</td></tr>
                    <tr><td className="text-muted text-sm w-50 border-0">Date</td><td className="text-primary border-0 text-right">{receipt.date !== null ? dateFormatter(receipt.date) : ""}</td></tr>
                    <tr><td className="text-muted text-sm w-50 border-0">Meter No:</td><td className="text-primary border-0 text-right">{receipt?.meterNo || "Nill"}</td></tr>
                    <tr>
                      <td className="text-muted text-sm w-50 border-0">Token</td>
                      <td className="text-primary border-0 text-right copy-text">
                        {receipt?.tokenCode || "Nill"}
                        <button className="btn-plain">
                          <FontAwesomeIcon icon={"copy"} className="text-success" onClick={() => handleCopy(receipt?.tokenCode || "Nill")} />
                        </button>
                      </td>
                    </tr>
                    <tr><td className="text-muted text-sm w-50 border-0">Transaction ID</td><td className="text-primary border-0 text-right">{receipt?.order}</td></tr>
                  </tbody>
                </table>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </Container>
    </Layout>
  );
};

export default LoanRequest;